<template lang="html">
  <header id="header">
    <div class="header-menu">
      <b-navbar toggleable="lg" type="light" variant="light">
        <div class="container med-container">
          <b-navbar-brand to="/">
            <img src="public/images/logo.png">
          </b-navbar-brand>

          <!-- <b-navbar-toggle target="nav-collapse"><i class="fa-light fa-bars"></i></b-navbar-toggle> -->

          <div class="d-inline d-lg-none">
            <router-link class="btn btn-s1 bg-1" to="/registro" v-if="$route.name != 'registerPage'">Aplicar ahora</router-link>
            <router-link class="btn btn-s1 outline-1" to="/" v-if="$route.name == 'registerPage'">Regresar al Inicio</router-link>
          </div>

          <b-collapse id="nav-collapse" is-nav>
            <!-- <b-navbar-nav class="mx-auto">
              <b-nav-item class="simple-item" to="/">xxxxxxx</b-nav-item>
              <b-nav-item class="simple-item" to="/">xxxxxxx</b-nav-item>
            </b-navbar-nav> -->

            <b-navbar-nav class="ml-auto navbar-btn">
              <router-link class="btn btn-s1 bg-1" to="/registro" v-if="$route.name != 'registerPage'">Aplicar ahora</router-link>
              <router-link class="btn btn-s1 outline-1" to="/" v-if="$route.name == 'registerPage'">Regresar al Inicio</router-link>
            </b-navbar-nav>
          </b-collapse>
        </div>
      </b-navbar>
    </div>
  </header>
</template>

<script>
export default {
}
</script>
